<template>
  <div class="auth-login">
    <section class="auth-login__img" />
    <section class="auth-login__content position-relative">
      <div class="auth-login__block">
        <router-link class="auth-login__logo" :to="{name: 'Home'}">
          <img src="@/assets/images/logo.svg" alt="logo" />
        </router-link>
        <el-form :model="form" :rules="rules" @submit.prevent.native="onSubmit" ref="form" class="auth-card">
          <h1 class="auth-login__title mt-0 mb-4">Вход для партнёров Hoff</h1>
          <div v-if="error" class="auth-login__error">{{ error }}</div>
          <el-form-item prop="username" class="auth-login__item" :class="{'is-error': error}">
            <el-input v-model.trim="form.username" :disabled="loading"/>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.username) }">Email</span>
          </el-form-item>
          <el-form-item prop="password" class="auth-login__item" :class="{'is-error': error}">
            <el-input v-model="form.password" show-password :disabled="loading"/>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.password) }">Пароль</span>
          </el-form-item>
          <div class="auth-login__actions">
            <div>
              <el-button type="primary" @click="onSubmit" class="w-100" :disabled="loading">Войти как партнёр Hoff</el-button>
            </div>
            <div>
              <a :href="keyCloakLink">
                <el-button type="primary" class="w-100 mt-3 el-button-primary-teal" :disabled="loading">Войти как сотрудник Hoff</el-button>
              </a>
            </div>
          </div>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

const keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_BASE_URL;
const keycloakRealmId = process.env.VUE_APP_KEYCLOAK_REALM_ID;
const keycloakClientId = process.env.VUE_APP_KEYCLOAK_CLIENT_ID;

const redirectUri = `${window.location.origin}/login-staff`; // 'http%3A%2F%2Flocalhost%3A8000%2Fcallback';

export default {
  data: () => ({
    error: null,
    form: {
      username: '',
      password: '',
    },
    keyCloakLink: `${keycloakBaseUrl}/realms/${keycloakRealmId}/protocol/openid-connect/auth`
      + `?client_id=${keycloakClientId}&response_type=code&redirect_uri=${redirectUri}`,
    rules: {
      username: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        { type: 'email', message: MESSAGES.INCORRECT_EMAIL, trigger: 'blur' },
      ],
      password: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
  }),

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
    }),
  },

  methods: {
    ...mapMutations({
      setCurrentUserLogin: 'auth/setCurrentUserLogin',
    }),
    ...mapActions({
      login: 'auth/login',
      loginByKeycloak: 'auth/loginByKeycloak',
    }),

    authentication(method, params) {
      return method(params)
        .then(() => {
          this.$router.push({ name: 'Home' });
        })
        .catch((err) => {
          if (err.data.error) {
            if (err.data.error === 'password_expired') {
              this.setCurrentUserLogin(this.form.username);
              this.$router.replace({ name: 'PasswordReset' });
            } else {
              this.error = err.data.error_description;
            }
          }

          throw err;
        });
    },
    onSubmit() {
      this.error = null;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.authentication(this.login, this.form);
        } else {
          return false;
        }
      });
    },
  },

  created() {
    const { code } = this.$route.query;
    if (code) {
      this.authentication(this.loginByKeycloak, { code, redirectUri })
        .catch(() => {
          this.$router.replace(this.$route.path);
        });
    }
  },
};
</script>
